export interface PainPoint {
  title: string
  body: string
}

export const painPoints: PainPoint[] = [
  {
    title: '😰 TOO MANY WELD DEFECTS. NOT ENOUGH VISUAL CLARITY.',
    body: 'Undercut? Lack of fusion? Porosity? Incomplete penetration? Some discontinuities look similar, while others require different examination methods. Understanding their differences becomes easier with organized visual references.',
  },
  {
    title: '⚠️ YOU KNOW THE TERMINOLOGY—BUT CAN YOU IDENTIFY THE INDICATION?',
    body: "Knowing welding defect definitions doesn't automatically make identification straightforward. Without clear visual comparisons, recognizing discontinuities, measuring profiles, and documenting findings can become challenging.",
  },
  {
    title: '📚 YOUR WELD INSPECTION REFERENCES ARE EVERYWHERE',
    body: "Welding diagrams, inspection procedures, NDT references, measurement guides, quality documents, and reporting templates. The information exists—but it's scattered across multiple resources when you need it.",
  },
  {
    title: '😩 STOP ORGANIZING EVERY INSPECTION RESOURCE FROM SCRATCH',
    body: 'Searching for defect examples, comparing weld indications, and preparing inspection documentation takes time. Use one structured visual system that brings essential welding inspection references together.',
  },
]
